import {defaultTheme} from 'sletat-ui-components2/dist/theme';
import {LESS_768_MEDIA_QUERY, LESS_960_MEDIA_QUERY} from '../../../../consts/adaptive';
import {cssToObject} from '../../../../../utils/cssToObject';
import {STATIC_HOST_NAME} from '../../../../../consts/hosts';

const { theme } = defaultTheme;

const claimLinesStyles = (linesAmount: number) => {
    return {
        display: '-webkit-box',
        overflow: 'hidden',
        textDecoration: 'inherit',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp' : linesAmount,
        lineClamp: linesAmount,
        '-webkit-box-orient': 'vertical',
    };
};

export const styles = {
  '@keyframes riseWidth': {
    from: { width: 0 },
    to: { width: '100%' },
  },
    roomCard: {
        display: 'flex',
        flexDirection: 'column',
        width: 'inherit',
        boxShadow: theme.shadowVariables.componentContainer,
        borderRadius: theme.borderRadiusVariables.main,
        padding: 16,
        backgroundColor: theme.colorVariables.bgPrimary,

        '&:hover': {
            cursor: 'pointer',
        },
    },
    mainContent: {
        flex: '1 0 auto',
        paddingTop: 0,
    },
    roomPlaceholder: {
        ...cssToObject(theme.mixin.fontTextS),
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23CACBCEFF' stroke-width='1' stroke-dasharray='12%2c 8' stroke-dashoffset='8' stroke-linecap='butt'/%3e%3c/svg%3e")`,
        borderRadius: 16,
        padding: 16,
        height: 'auto',
        minHeight: 196,
        marginTop: 'auto',
        flex: '1 1 auto',
        color: theme.colorVariables.textNote,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
    roomPlaceholderImage: {
        width: 'auto',
        height: 212,
        backgroundImage: `url(\'https://${STATIC_HOST_NAME}/images/placeholder/room/placeholderNoRoomPhoto.jpg\')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderRadius: theme.borderRadiusVariables.main,
        backgroundPosition: 'center'
    },
    roomName: {
        ...cssToObject(theme.mixin.fontSubtitleS),
        margin: '1rem 0 0.5rem',
        color: theme.colorVariables.textDark,
        ...claimLinesStyles(2)
    },
    roomParams: {
        ...cssToObject(theme.mixin.fontTextXS),
        margin: '0 0 0.5rem',
        color: theme.colorVariables.textNoteDark,
        ...claimLinesStyles(2),
    },
    roomDescription: {
        ...cssToObject(theme.mixin.fontTextXS),
        margin: '0 0 1rem',
        ...claimLinesStyles(4)
    },
    roomFacilities: {
        margin: ' auto 0 1rem'
    },
    buttons: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    infoButton: {
        width: 168
    },
    roomFacilitiesButtons: {
        display: 'flex',
        flexFlow: 'row wrap',
        gap: '0.25rem',
        // отображаем 2 строки тегов + отступ
        maxHeight: 'calc(2 * 1.5rem + 0.25rem)',
        overflow: 'hidden',
    },
    facilityButton: {
        ...cssToObject(theme.mixin.fontTextXS),
        position: 'relative',
        height: '1.5rem',
        padding: '0.25rem 0.5rem',
        color: theme.colorVariables.textDark,
        border: `1px solid ${theme.colorVariables.borderPrimary}`,
        borderRadius: theme.borderRadiusVariables.btn,
    },
    swiper: {
        width: '100%',
        height: '100%',
        minHeight: '160px',
        borderRadius: theme.borderRadiusVariables.main,
    },
    sliderBullets: {
        width: 'auto',
        height: '4px',
        display: 'block',
        borderRadius: 2,
        border: 'none',
        cursor: 'pointer',
        flex: '1 1 auto',
        opacity: '1',
        background: theme.colorVariables.bgPrimary,
        transition: 'all 300ms ease-in-out',
        position: 'relative',

        '&:hover': {
            backgroundColor: theme.colorVariables.bgPrimary,
        },

        '.swiper-container-horizontal>.swiper-pagination-bullets &': {
            margin: 0,
        },
    },
    activeSliderBullets: {
        width: 'auto',
        height: '4px',
        display: 'block',
        borderRadius: 2,
        border: 'none',
        cursor: 'pointer',
        flex: '1 1 auto',
      background: 'rgba(255, 255, 255, 0.5)',

      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        width: 0,
        height: '4px',
        borderRadius: 2,
        background: theme.colorVariables.bgPrimary,
        animation: 'riseWidth 0.3s linear',
        animationFillMode: 'forwards',
      },
      '& ~ button ': {
        background: 'rgba(255, 255, 255, 0.5)',
      },
    },
    sliderWrapper: {
        position: 'relative',
        overflow: 'hidden',
        flex: '0 0 auto',
        height: 212,
        display: 'grid',
        paddingTop: 0
    },

    randomTag: {
        ...cssToObject(theme.mixin.fontCaptionM_Caps),
        position: 'absolute',
        left: 0,
        top: 0,
        padding: '0.5rem 1rem',
        zIndex: 10,
        color: theme.colorVariables.textLight,
        background: theme.colorVariables.iconPrimary,
        borderRadius: [theme.borderRadiusVariables.main, 0, theme.borderRadiusVariables.main, 0],
        boxShadow: theme.shadowVariables.componentContainer,
    },

    swiperPagination: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'row nowrap',
        justifyContent: 'flex-start',
        width: '100%',
        margin: 0,
        gap: '4px',

        '&.swiper-pagination.swiper-pagination-bullets': {
            padding: [0, 16],
            bottom: 12,
        },
    },
    sliderNavButtonPrev: {
        opacity: '0.8',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        top: '40%',
        height: 40,
        padding: [0, 16, 0],
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
        zIndex: 10,
        left: 0,
        transform: 'rotate(180deg)',

        '&:hover': {
            opacity: 1
        }
    },

    sliderNavButtonNext: {
        opacity: '0.8',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        top: '40%',
        height: 40,
        padding: [0, 16, 0],
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
        zIndex: 10,
        right: 0,

        '&:hover': {
            opacity: 1
        }
    },
    [LESS_960_MEDIA_QUERY]: {
        roomParams: {
            ...claimLinesStyles(3)
        },
        button: {
            width: '100% !important',
        },
    },
    [LESS_768_MEDIA_QUERY]: {
        sliderWrapper: {
            width: '100%',
        },
        roomPlaceholder: {
            marginTop: 8,
        },
        roomName: {
            ...claimLinesStyles(3)
        },
        roomParams: {
          margin: '0 0 1rem',
        },
        roomFacilitiesButtons: {
          // отображаем 3 строки тегов + отступы
          maxHeight: 'calc(3 * 1.5rem + 2 * 0.25rem)',
        },
        infoButton: {
            width: '100%',
        },
        roomDescription: {
          display: 'none'
        },
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
